import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Api, Code } from '@.api';
import { Layout } from '@.layout';
import { IForm, useId } from '@/Components/Hooks';
import { ParentCompanyForm } from '@/Components/Partials/ParentCompany';
import { LinkHelper } from '@/Services';
import { ParentCompanyCreateType, ParentCompanyResource } from '@/Types/ParentCompany';

export const ParentCompanyEditPage = () => {
    const navigate = useNavigate();

    const [parentCompany, setParentCompany] = useState<ParentCompanyResource | null>(null);

    const parentCompanyId = useId((id) => {
        const fetch = async () => {
            const response = await Api.parentCompany().getById(id);

            if (response.code !== Code.Success) {
                throw response;
            }

            setParentCompany(response.data.parent_company);
        };

        void fetch();
    });

    const save = async (data: ParentCompanyCreateType, form: IForm<ParentCompanyCreateType>) => {
        const response = await Api.parentCompany().update(parentCompanyId, data);

        if (response.code === Code.ValidationError) {
            form.set.errors(response.errors);
            return;
        }

        if (response.code === Code.Success) {
            navigate(LinkHelper.parentCompanies.all);
        }

        throw response;
    };

    return (
        <Layout name="Parent company" small breadcrumbs={[{ name: 'Parent Company' }, { name: 'Edit' }]}>
            <h1>Edit parent company</h1>

            {parentCompany && <ParentCompanyForm onSave={save} initial={parentCompany} isEdit />}
        </Layout>
    );
};
